export const enum OWNERSHIP_TYPE {
  rental = 'Аренда',
  ownership = 'Собственность',
  leasing = 'Лизинг',
}

export const OWNERSHIP_TYPE_OPTIONS = [
  {
    name: 'Аренда',
    value: 'rental',
  },
  {
    name: 'Собственность',
    value: 'ownership',
  },
  {
    name: 'Лизинг',
    value: 'leasing',
  },
];
